<template>
    <div class="edit-student-container">
        <div class="edit-student">
            <h2>Edit Student</h2>
            <form @submit.prevent="updateStudent">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input v-model="student.name" type="text" id="name" required />
                </div>
                <div class="form-group">
                    <label for="dob">Date of Birth</label>
                    <input v-model="student.birth_date" type="date" id="dob" required />
                </div>
                <div class="form-group">
                    <label for="class">Class</label>
                    <input v-model="student.class_name" type="text" id="class" required />
                </div>
                <div class="form-group">
                    <label for="gender">Gender</label>
                    <select v-model="student.gender" id="gender" required>
                        <option value="male" :selected="student.gender == 'male'">Male</option>
                        <option value="female" :selected="student.gender == 'female'">Female</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="address">Address</label>
                    <input v-model="student.address" type="text" id="address" required />
                </div>

                <div class="form-group">
                    <label for="image">Image</label>
                    <input type="file" id="image" name="image" @change="handleImageChange" />
                </div>

                <div class="form-group">
                    <label for="contact">Contact</label>
                    <input v-model="student.contact" type="text" id="contact" required />
                </div>
                <div class="form-group">
                    <label for="parent_name">Parent's Name</label>
                    <input v-model="student.parent_name" type="text" id="parent_name" required />
                </div>
                <button type="submit">Update</button>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, defineProps } from "vue";
import axios from "axios";
import { apiConfig } from "@/config/apiConfig"; // Import API config

const props = defineProps({
    studentData: {
        type: Object,
        required: true,
    },
});

const student = ref({ ...props.studentData });
const successMessage = ref("");
const error = ref(null);

const emit = defineEmits(["updateStudent"]);

// Watch for updates to `studentData` prop and update the local `student` object
watch(
    () => props.studentData,
    (newStudent) => {
        student.value = { ...newStudent };
    },
    { deep: true }
);


const handleImageChange = (event) => {
    const file = event.target.files[0]; // Get the first file
    if (file) {
        student.value.image = file; // Set it to the student data
    }
};

const updateStudent = async () => {
    const accessToken = localStorage.getItem("accessToken");
    const updatedData = { ...student.value };
    try {
        // Create a FormData object
        const formData = new FormData();
        Object.keys(updatedData).forEach((key) => {
            if (key !== "image") {
                formData.append(key, updatedData[key]);
            }
        });
        if (student.value.image && student.value.image instanceof File) {
            
            formData.append("image", student.value.image);
        }

        const response = await axios.patch(
            `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
            formData,
            {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data", // Important for file uploads
                    "STUDENT-ID": updatedData.id,
                },
            }
        );
        // for (let pair of formData.entries()) {
        //     console.log(pair[0], pair[1]);
        // }
        emit("updateStudent", response.data);

        successMessage.value = "Student updated successfully!";
        //console.log("Update response:", response.data);
    } catch (err) {
        error.value = `Error updating student: ${err.response ? err.response.data : err.message}`;
    }
};
</script>


<style scoped>
.edit-student-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f3f4f6;
    padding: 1rem;
    overflow: hidden;
}

.edit-student {
    max-width: 600px;
    width: 100%;
    padding: 2rem;
    background-color: #ffffff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    font-family: "Arial", sans-serif;
    max-height: 90vh;
    /* Limit form height */
    overflow-y: auto;
    /* Enable scrolling for content overflow */
}

h2 {
    text-align: center;
    color: #333;
    margin-bottom: 2rem;
    font-size: 1.8rem;
    font-weight: bold;
}

.form-group {
    margin-bottom: 1.5rem;
}

label {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #555;
}

input,
select {
    width: 100%;
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
    transition: border-color 0.3s, box-shadow 0.3s;
    outline: none;
}

input:focus,
select:focus {
    border-color: #4caf50;
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.4);
}

button {
    width: 100%;
    padding: 0.75rem;
    font-size: 1rem;
    background-color: #4caf50;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.3s, transform 0.2s;
}

button:hover {
    background-color: #45a049;
    transform: scale(1.02);
}

button:active {
    background-color: #3d8b41;
}

@media (max-width: 768px) {
    .edit-student {
        padding: 1.5rem;
    }

    h2 {
        font-size: 1.5rem;
    }

    button {
        font-size: 0.9rem;
    }
}
</style>
